<template>
  <main :id="$style.main">
    <!-- <about-top-visual v-if="flag===0" @child_event="handleClick"></about-top-visual> -->
    <about-select-pannel
      :class="$style.pannel"
      @child_event="handleClick"
      :flag="flag"
    ></about-select-pannel>
    <about-history-visual v-if="flag == 1"></about-history-visual>
    <about-medal-visual v-if="flag == 2"></about-medal-visual>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
// import AboutTopVisual from "@/components/organsms/about/AboutTopVisual.vue";
import AboutSelectPannel from "@/components/molecules/AboutSelectPannel.vue";
import AboutHistoryVisual from "@/components/organsms/about/AboutHistoryVisual.vue";
import AboutMedalVisual from "@/components/organsms/about/AboutMedalVisual.vue";

export default Vue.extend({
  name: "AboutView",

  components: {
    // AboutTopVisual,
    AboutHistoryVisual,
    AboutMedalVisual,
    AboutSelectPannel,
  },

  data() {
    return {
      flag: 1,
    };
  },
  mounted() {
    this.handleClick(this.$route.params.id);
  },
  methods: {
    handleClick(flag) {
      this.flag = flag;
    },
  },
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";
@media only screen and (max-width: 1023px) {
  #main {
    padding: 0;
    background-color: #000;
    min-height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
  }
}
@media only screen and (min-width: 1024px) {
  #main {
    padding: 0;
    background-color: #000;
    min-height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
  }
}
</style>
